import ApiService from '../services/apiService';

const indexHealthPrevisionsRequest = ({ dispatch, params = {}, failureCallback, successCallback }) =>
  ApiService.request('get', '/health_previsions', {
    dispatch,
    params,
    failureCallback,
    successCallback
  });

export const exportHealthPrevisionRequest = ({
  dispatch,
  format = '.xlsx',
  responseType = 'text',
  params = {},
  callback,
  successCallback
}) =>
  ApiService.request('get', `/health_previsions/export${format}`, {
    dispatch,
    params,
    responseType,
    successCallback,
    callback
  });

export default indexHealthPrevisionsRequest;
